
import { ElectricalAspectEntityDecorator } from '../../aspects/model/electrical-aspect.decorator';
import { ElectricalAspect } from '../../aspects/model/electrical-aspect.model';
import { MaintenanceAspectEntityDecorator } from '../../aspects/model/maintenance-aspect.decorator';
import { MaintenanceAspect } from '../../aspects/model/maintenance-aspect.model';
import { MechanicalAspectEntityDecorator } from '../../aspects/model/mechanical-aspect.decorator';
import { MechanicalAspect } from '../../aspects/model/mechanical-aspect.model';
import { AssetTypeEntityDecorator } from '../../assettype/model/asset-type.decorator';
import { AssetType } from '../../assettype/model/asset-type.model';
import { BusinessUnitEntityDecorator } from '../../businessunit/model/business-unit.decorator';
import { BusinessUnit } from '../../businessunit/model/business-unit.model';
import { CostCentreEntityDecorator } from '../../costcentre/model/cost-centre.decorator';
import { CostCentre } from '../../costcentre/model/cost-centre.model';
import { ASSET_METADATA } from './asset.metadata';
import { Asset } from './asset.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class AssetEntityDecoratorBase extends GenericEntityDecorator<Asset, number> {
  constructor() {
    super(ASSET_METADATA, {
      get assetType(): EntityDecorator<AssetType, number> {
        return new AssetTypeEntityDecorator();
      },
      get businessUnit(): EntityDecorator<BusinessUnit, string> {
        return new BusinessUnitEntityDecorator();
      },
      get costCentre(): EntityDecorator<CostCentre, string> {
        return new CostCentreEntityDecorator();
      },
      get electricalAspect(): EntityDecorator<ElectricalAspect, number> {
        return new ElectricalAspectEntityDecorator();
      },
      get maintenanceAspect(): EntityDecorator<MaintenanceAspect, number> {
        return new MaintenanceAspectEntityDecorator();
      },
      get mechanicalAspect(): EntityDecorator<MechanicalAspect, number> {
        return new MechanicalAspectEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): number {
    if (params == null || params.assetId == null) {
      return null;
    }
    return parseInt(params.assetId);
  }
  toKeyUrlPathSegments(key: number): string {
    if (key == null) {
      return null;
    }
    return '' + key;
  }
  toKeyRouteSegments(item: Asset): any[] {
    const key: number = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




